export default __webpack_public_path__ + "static/Plate_2x2_Sand_RGB-2887ac476acc332b8f780322a7b5d733.svg";